import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DoubleTextSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const SubscriptionCustomerListItemLoadingTablet: React.FC = () => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack space="stack.xxxs">
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/4">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="1/4">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="1/4">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="1/4">
              <DoubleTextSkeleton />
            </Stack>
          </HStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/4">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="1/2">
              <InputSkeleton />
            </Stack>
            <Stack w="1/4" alignItems="end">
              <TextSkeleton />
            </Stack>
          </HStack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
